import { setSortable } from '../utils.js';

export function checkboxListHandler() {
	this.$checkbox_list = $('.checkbox_list');
	this.$list;
	this.div;
	this.input;

	this.init = function () {
		setSortable(this.$checkbox_list.find('.selection'), 'li', '');

		window.$page.on('click', '.checkbox_list:not(.disabled) .choices li', function (e) {
			let $input = $(this);
			$input.parents('.checkbox_list').find('.selection').append($input);
			document.dispatchEvent(new CustomEvent('checkbox_handler_added', { 'detail': this.value }));
		});
		window.$page.on('click', '.checkbox_list:not(.disabled) .selection:not(.sort_only) li', function (e) {
			let $input = $(this);
			$input.parents('.checkbox_list').find('.choices').append($input);
			document.dispatchEvent(new CustomEvent('checkbox_handler_removed', { 'detail': this.value }));
		});
	}
	this.run = function () {
		return new Promise(function (resolve, reject) {
			this._loop(function (index) {
				this.input.name = $(this.checkbox).attr('data-input-name') + '[' + index + ']';
				this.input.value = $(this.li).attr('data-choice');
				$(this.div).append($(this.input).clone());
			}.bind(this), '.selection li');
			resolve(true);
		}.bind(this));
	}
	this.load = function () {
		return new Promise(function (resolve, reject) {
			this._loop(function () {
				this._toggle($(this.li));
				$(this.li).removeClass('checked');
			}.bind(this), '.choices li.checked');
			resolve(true);
		}.bind(this));
	}
	this.reset = function () {
		return new Promise(function (resolve, reject) {
			this._loop(function () {
				this._toggle($(this.li));
			}.bind(this), '.selection li');
			resolve(true);
		}.bind(this));
	}
	this._toggle = function ($li) {
		if ($li.parent().hasClass('selection')) {
			$li.parents('.checkbox_list').find('.choices').append($li);
		} else if ($li.parent().hasClass('choices')) {
			$li.parents('.checkbox_list').find('.selection').append($li);
		}
	}
	this._loop = function (cb, target) {
		if (this.$checkbox_list.length > 0) {
			this.input = document.createElement('input');
			this.input.type = 'hidden';
			this.$checkbox_list.each(function (index, checkbox) {
				this.checkbox = checkbox;
				if (typeof $(this.checkbox).attr('data-input-name') === 'undefined') {
					console.error('checkbox input should contains a data-input-name');
					return false;
				}
				this.$list = $(this.checkbox).find(target);
				this.$list.sort(this._sort);
				this.div = $(this.checkbox).find('.checkbox_input');
				this.div.html('');
				if (this.$list.length > 0) {
					this.$list.each(function (index, li) {
						this.index = index;
						this.li = li;
						cb(index);
					}.bind(this));
				}
			}.bind(this));
		}
	}
	this._sort = function (a, b) {
		let aO = parseInt(a.dataset.order);
		let bO = parseInt(b.dataset.order);
		if (typeof aO !== 'undefined' &&
			typeof bO !== 'undefined'
		) {
			return (aO < bO ? -1 : aO > bO ? 1 : 0);
		}
		return 0;
	}
}
